import React from "react";
import { Input } from "antd";

import { lineByKey as L } from "../../TreatmentPlans/lib/procedureFamilies";
import { Field, YesNo } from "./fields";

/**
 * Step 3 — who is covered, and the plan-wide limits.
 *
 * Dependant and full-time-student ages sit here because they decide whether a
 * family member is claimable at all; on the paper form they share a line for the
 * same reason, and they get their own line in the shortform.
 */
export default function EligibilityStep({ value, onChange }) {
  function set(k, v) { onChange(Object.assign({}, value, { [k]: v })); }
  return (
    <div className="bw-card">
      <p className="bw-card-title">Eligibility &amp; ages</p>
      <div className="bw-grid">
        <Field label="Dependent child covered to age">
          <Input suffix="yrs" value={value.dependentAge || ""} onChange={function (e) { set("dependentAge", e.target.value); }} />
        </Field>
        <Field label="Full-time students covered to age">
          <Input suffix="yrs" value={value.ftStudentAge || ""} onChange={function (e) { set("ftStudentAge", e.target.value); }} />
        </Field>
        <Field label="Nitrous covered" code={L.nitrous.templateCode}>
          <YesNo value={value.nitrous || ""} onChange={function (v) { set("nitrous", v); }} />
        </Field>
        <Field label="Examination limitations" span
          hint='Be specific — "any 2 exams a year" and "2 emergency exams a year" are different plans.'>
          <Input value={value.examLimitations || ""}
            placeholder="e.g. Any 2 exams in a year"
            onChange={function (e) { set("examLimitations", e.target.value); }} />
        </Field>
        <Field label="Other plan limitations" span>
          <Input.TextArea autoSize={{ minRows: 2, maxRows: 5 }} value={value.limitations || ""}
            placeholder="Anything the carrier flagged that does not fit a field above"
            onChange={function (e) { set("limitations", e.target.value); }} />
        </Field>
      </div>
    </div>
  );
}
